import { Link } from "gatsby"
import React from "react"
import LogoWhite from "../../images/pharms-logo-white.svg"
import Section from "../Section"
import Grid from "../Grid"
import Text from "../Text"
import { footer, footerItem, footerItemTitle, footerWrapper, footerList, footerListBottom } from "./footer.module.scss"

export default React.memo(() => {
  return (
    <footer className={footer}>
      <Section>
        <Grid className={footerWrapper} column="five" use="footer">
          <Link to="/">
            <img src={LogoWhite} alt="かかりつけ薬局支援システム Pharms（ファームス）" width="120px" />
          </Link>
          <ul className={footerList}>
            <li className={footerItemTitle}>
              <Text>Pharmsとは</Text>
            </li>
            <li className={footerItem}>
              <Link to="/product/">選ばれる理由</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/function">機能一覧</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/flow/">導入の流れ</Link>
            </li>
            <li className={footerItem}>
              <Link to="/security/" target="_blank">セキュリティ</Link>
            </li>
          </ul>
          <ul className={footerList}>
            <li className={footerItemTitle}>
              <Text>機能</Text>
            </li>
            <li className={footerItem}>
              <Link to="/product/delivery/">当日配達機能</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/online/">オンライン服薬指導</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/followup/">服薬フォローアップ</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/medicalnote/">お薬手帳</Link>
            </li>
            <li className={footerItem}>
              <Link to="/product/checkin/">店舗チェックイン</Link>
            </li>
          </ul>
          <ul className={footerList}>
            <li className={footerItemTitle}>
              <Link to="/support/">サポート</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/price/">料金</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/case/" target="_blank">導入事例</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/event/" target="_blank">セミナー</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/column/" target="_blank">お役立ち</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/form/inquiry" target="_blank">お問い合わせ</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="https://www.medley.jp/" target="_blank">運営会社</Link>
            </li>
            <li className={footerItemTitle}>
              <Link to="/terms/guideline-checksheet" target="_blank">電子版お薬手帳ガイドラインに係るチェックシートの公表</Link>
            </li>
          </ul>
          <ul className={footerList}>
            <li className={footerItemTitle}>
              <Text>メドレーのプロダクト</Text>
            </li>
            <li className={footerItem}>
              <Link to="https://clinics-cloud.com/" target="_blank">クラウド診療支援システム「CLINICS」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://dentis-cloud.com/" target="_blank">クラウド歯科業務支援システム「Dentis」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://clinics-app.com/" target="_blank">オンライン診療・服薬指導アプリ「CLINICS」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://medley.life/" target="_blank">医師たちがつくるオンライン医療事典「MEDLEY」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://job-medley.com/" target="_blank">医療介護求人サイト「ジョブメドレー」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://kaigonohonne.com/" target="_blank">納得できる老人ホーム選び「介護のほんね」</Link>
            </li>
            <li className={footerItem}>
              <Link to="https://www.lalu.jp/" target="_blank">女性向け生理予測・妊活アプリ「Lalune(ラルーン)」</Link>
            </li>
          </ul>

        </Grid>
        <address>&copy;2020 MEDLEY, INC.</address>
      </Section>
    </footer>
  )
});
